<template>
    <el-form :model="devcGroup" :rules="devcGroupRules" ref="devcGroup" class="demo-ruleForm">
        <div class="simple-form">
            <div class="form-group center">
                <div class="form-label">
                    <label class="required">名称</label>
                </div>
                <div class="form-value width-1-5x">
                    <el-form-item prop="name">
                        <el-input v-model="devcGroup.name" placeholder="请输入"></el-input>
                    </el-form-item>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>编码</label>
                </div>
                <div class="form-value width-1-5x">
                    <el-form-item prop="code">
                        <el-input v-model="devcGroup.code" placeholder="请输入"></el-input>
                    </el-form-item>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>说明</label>
                </div>
                <div class="form-value width-1-5x">
                    <el-form-item prop="desc">
                        <el-input class="textarea-value" type="textarea" v-model="devcGroup.desc"></el-input>
                    </el-form-item>
                </div>
            </div>
        </div>

    </el-form>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'
    //
    import goodsCategApi from '../../api/goodsCateg'
    //
    export default {
        name: 'swb-devc-group-save',
        desc: '保存维保分组',
        props: ['id', 'parentId'],
        data: function () {
            // 校验
            let validateName = function (rule, value, callback) {
                if(Utils.isNoB(value)) {
                    callback(new Error('名称不能为空'));
                } else {
                    callback();
                }
            };
            return {
                //
                devcGroup: {
                    code: null,
                    parentId: -1,
                    level: 1,
                    desc: null
                },
                // 校验
                devcGroupRules: {
                    name: [
                        {validator: validateName, trigger: 'blur'}
                    ]
                }
            }
        },
        created: function () {
            if(!Utils.isNoB(this.id)) {
                this.toGetDevcGroup();
            }
            if(!Utils.isNoB(this.parentId)) {
                this.devcGroup.parentId = this.parentId;
                this.devcGroup.level = 2;
            }
        },
        methods: {
            toGetDevcGroup: function () {
                let self = this;
                let postData = {};
                postData.id = self.id;
                //
                let msgBoxDlg = MsgBox.loading();
                goodsCategApi.getDevcGroup(postData, function (result) {
                    msgBoxDlg.close();
                    if(result.type == "info") {
                        self.devcGroup = result.data;
                    } else {
                        MsgBox.warning(result.message);
                    }
                })
            },
            getDlgResult: function () {
                let self = this;
                let result = {};
                self.$refs.devcGroup.validate(function (valid) {
                    if(valid) {
                        result.type = "info";
                        result.data = self.devcGroup;
                    } else {
                        result.type = "warn";
                        result.message = "校验失败";
                    }
                });
                return result;
            }
        }
    }

</script>



// WEBPACK FOOTER //
// src/compo/categ/DevcGroupSave.vue